// modules/b2b/modals/forms/FormCreateCompanyB2B.tsx
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import InputFormik from "@/common/components/form/InputFormik";
import { maskCNPJ, maskPhone } from "@/common/helpers/mask.helpers"; // Assumindo que você tem esta máscara
import { ICompanyB2B } from "@/types/companyB2B.type";
import AddressFields from "@/modules/renters/components/forms/fields/AddressFields";

// Esquema de validação com Yup
const validationSchema = Yup.object().shape({
  socialReason: Yup.string().required("Razão Social é obrigatória."),
  name: Yup.string().required("Nome Fantasia é obrigatório."),
  cnpj: Yup.string().required("CNPJ é obrigatório"),
  email: Yup.string().email("E-mail inválido").required("E-mail é obrigatório."),
  phone: Yup.string().required("Número de Contato é obrigatório."),
  openingDate: Yup.string(),
});

type FormValues = Pick<
  ICompanyB2B,
  "socialReason" | "name" | "cnpj" | "phone" | "email" | "openingDate" | "address"
>;

type FormPropsCreateCompanyB2B = {
  onSubmit: (values: FormValues) => Promise<void>;
};

function FormCreateCompanyB2B(props: FormPropsCreateCompanyB2B) {
  const initialValues: FormValues = {
    socialReason: "",
    name: "",
    cnpj: "",
    phone: "",
    email: "",
    openingDate: "",
    address: {
      street: "",
      number: "",
      complement: "",
      neighborhood: "",
      city: "",
      state: "",
      zipCode: "",
    },
  };

  const handleSubmit = async (values: FormValues, { setSubmitting }) => {
    setSubmitting(true);
    await props.onSubmit(values);
    setSubmitting(false);
  };


  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, handleSubmit }) => (

        <Form className="flex flex-col gap-6 ">
          {/* Dados da Empresa */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputFormik
              label="Razão Social:"
              name="socialReason"
              className="w-full"
              required={true}
            />
            <InputFormik
              label="Nome Fantasia:"
              name="name"
              className="w-full"
              required={true}
            />
            <InputFormik
              label="CNPJ:"
              name="cnpj"
              mask={maskCNPJ}
              className="w-full"
              required={true}
            />
            <InputFormik
              label="E-mail:"
              name="email"
              type="email"
              required={true}
            />
            <InputFormik
              label="Data de Abertura:"
              name="openingDate"
              type="date"
              className="w-full"
              required={true}
            />
            <InputFormik
              label="Número de Contato:"
              name="phone"
              mask={maskPhone}
              className="w-full"
              required={true}
            />
          </div>

          {/* Endereço */}
          <section className="style-endereco">
            <h2 className="section-name">Endereço</h2>
            <AddressFields />
          </section>

          <div className="flex justify-end pt-4">
            <ButtonWithLoader isLoading={isSubmitting} onClick={handleSubmit}>
              Cadastrar
            </ButtonWithLoader>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default FormCreateCompanyB2B;
